// src/components/ui/ModernCard.js
import React from 'react';
import { theme } from '../../theme/colors';

const ModernCard = ({ 
  children, 
  title, 
  subtitle,
  padding = 'md',
  shadow = 'none',
  ...props 
}) => {
  const paddingValue = theme.spacing[padding] || theme.spacing.xl;

  return (
    <div 
      style={{
        backgroundColor: theme.colors.cardBackground,
        borderRadius: '0',
        // Remove shadow to avoid 'cards within cards' visual effect
        boxShadow: 'none',
        overflow: 'hidden',
        ...props.style
      }}
      {...props}
    >
      {(title || subtitle) && (
        <div style={{
          padding: paddingValue,
         // borderBottom: `1px solid ${theme.colors.border}`,
          marginTop: '6.5%',
          backgroundColor: '#ffffff'
        }}>
          {title && (
            <h2 style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: theme.colors.text.primary,
              margin: '0',
              marginBottom: subtitle ? theme.spacing.xs : '0'
            }}>
              {title}
            </h2>
          )}
          {subtitle && (
            <p style={{
              fontSize: '0.875rem',
              color: theme.colors.text.secondary,
              margin: '0'
            }}>
              {subtitle}
            </p>
          )}
        </div>
      )}
      <div style={{ padding: paddingValue }}>
        {children}
      </div>
    </div>
  );
};

export default ModernCard;